const _ = require('lodash');
let _api;

function groupSettings(settings) {
    return _.keyBy(settings, function (setting) {
        return setting.Group + '-' + setting.Name;
    });
}

function SettingsService(restangular, $rootScope, $q, bootstrap) {
    _api = restangular.all('Settings');
    this.restangular = restangular;
    this.settings = null;
    this.frontEndSettings = [{
        Group: 'StorePages',
        Name: 'StorePagesRedirect',
        Value: '{\r\n  "EnableRedirect": false,\r\n  "RedirectBaseUrl": "https://store.bws.com.au/storelocator"\r\n}'
    }];
    this.q = $q;
    this.bootstrap = bootstrap;
    this.adsStockCodes = [];
    this.bannerAds = [];

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.Settings)) {
        this.settings = $q
            .when(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Settings))
            .then(groupSettings);
    }

    $rootScope.$on('login:success', () => {
        this.invalidateAndUpdateSettings();
    });

    this.updateSettings();
}

SettingsService.prototype.updateSettings = function () {
    if (!_.isNull(this.settings)) {
        return this.settings;
    }

    this.settings = _api.getList().then(groupSettings);

    return this.settings;
};

SettingsService.prototype.getSettingValue = function (group, name) {
    if (_.isNull(this.settings)) {
        // Initialize settings if undefined
        this.updateSettings();
    }

    return this.settings.then(function (settings) {
        const setting = settings[group + '-' + name];
        return setting ? setting.Value : undefined;
    });
};

SettingsService.prototype.invalidate = function () {
    this.settings = null;
};

SettingsService.prototype.getAdsStockCodes = function () {
    return this.adsStockCodes;
};

SettingsService.prototype.setAdsStockCodes = function (stockCodes) {
    this.adsStockCodes = stockCodes;
};

SettingsService.prototype.removeAdsStockCode = function (stockCode) {
    _.remove(this.adsStockCodes, function (p) {
        return (p === stockCode);
    });
};

SettingsService.prototype.invalidateAdsStockCodes = function () {
    this.adsStockCodes = [];
};

SettingsService.prototype.invalidateAndUpdateSettings = function () {
    this.invalidate();
    this.updateSettings();
    // Clear front end settings
    this.frontEndSettings.splice(0, this.frontEndSettings.length);
};

SettingsService.prototype.getFrontendSetting = function (group, name) {
    // Get setting from array if it has already been retrieved
    const setting = this.frontEndSettings.length
        ? _.find(this.frontEndSettings, function (o) {
            return o.Group === group && o.Name === name;
        })
        : undefined;

    return setting
        ? this.q.resolve([setting])
        : this.restangular.one('FrontendSettings').get({ Group: group, Name: name }).then((response) => {
            this.frontEndSettings.push(response[0]);
            return response;
        });
};

/**
 *
 * @param {string} setting The setting value
 * @param {object} map // The map of values to parse
 * @param {templateLiteral} fallback  // This what to do if the embeded value is not matched; Default to retain
 *
 * @returns parsed string
 *
 * For example using a string from a setting value
 *
 *     const settingValue = "The quick ${color} fox is jumps over the ${obstacle}" // This is a string, not a es6 template literal
 *
 *     const message = SettingsService.parseEmbeddedValues(settingValue, {color: 'red', obstacle: 'fence'})
 *
 *     console.log(message); // "The quick red fox jumps over the fence"
 *
 */
SettingsService.prototype.parseEmbeddedValues = function (setting, map, fallback) {
    const get = function (path, obj, fb = `$\{${path}}`) {
        return path.split('.').reduce((res, key) => res[key] || fb, obj);
    };

    // replaces embedded expressions as if the string were a template literal
    return setting.replace(/\$\{.+?}/g,
        (match) => {
            const path = match.substr(2, match.length - 3).trim();
            return get(path, map, fallback);
        });
};

SettingsService.prototype.getPageModelData = function (key) {
    return this.bootstrap.getPageModelData(key);
};

module.exports = SettingsService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/settings/settings-service.js
 **/